import React, { Fragment } from 'react'

const BkFlowEditGuestSelect = props => {
  const {
    currentGuestData,
    hotelLabels,
  } = props

  return (
    <Fragment>
      <div className="bk-flow-edit-guest__field-select-input">
        <p className="u-remove-margin u-font-small">
          { currentGuestData && currentGuestData.adults ? currentGuestData.adults : '--' }&nbsp;
          { currentGuestData && (Number(currentGuestData.adults) === 0 || Number(currentGuestData.adults) > 1) ?
            hotelLabels.adults ? hotelLabels.adults : 'Adults'
          :
            hotelLabels.adult ? hotelLabels.adult : 'Adult'
          },&nbsp;
          { currentGuestData && Number(currentGuestData.children) >= 0 ? currentGuestData.children : '--' }&nbsp;
          { currentGuestData && (Number(currentGuestData.children) === 0 || Number(currentGuestData.children) > 1) ?
            hotelLabels.children ? hotelLabels.children : 'Children'
          :
            hotelLabels.child ? hotelLabels.child : 'Child'
          }
        </p>
        <i className="bk-flow-edit-guest__field-select-arrow material-icons">arrow_drop_down</i>
      </div>
    </Fragment>
  )
}

export default BkFlowEditGuestSelect



// WEBPACK FOOTER //
// ./src/components/edit/guest/layouts/BkFlowEditGuestSelect.js